// Multi Sede Usuarios: la PRIMERA sede seleccionada es la primaria (TMUSE10.SedCod);
// todas se registran en el detalle TMUSE20. Compañía, sucursal y sedes se
// configuran en el modal "Accesos por organización" (UsuarioFormOrganizacion).
import type { UsuarioFormCamposProps } from "./UsuarioFormCampos.types";
import { UsuarioFormOrganizacion } from "./UsuarioFormOrganizacion";

// Cabecera del formulario: foto con el botón de acción, organización y usuario.
export const UsuarioFormCabecera = (props: UsuarioFormCamposProps) => {
    const { accion, imagenbase, handleSubmit, onSubmitCrear, onSubmitEditar, register, errors } = props
    return (
            <div className="col-12">
                <div className="row ">
                    <div className="col-12 col-lg-6 ">
                        <div className="card align-items-center" style={{ maxHeight: "360px", maxWidth: "360px" }}>
                            <img style={{ maxHeight: "200px", maxWidth: "200px" }} src={imagenbase} className="col-12 img-fluid img-thumbnail" alt="user"></img>
                            <div className="col-12 row">
                                <div className='mt-2 botones-accion text-center'>
                                    {
                                        accion === "agregar" && (
                                            <button className='btn btn-sm btn-primario col-md-3' type="submit" form="CreateForm" onClick={handleSubmit(onSubmitCrear)}>Cargar</button>
                                        )
                                    }
                                    {
                                        accion === "editar" && (
                                            <button className='btn btn-sm btn-primario col-md-3' type="submit" form="CreateForm" onClick={handleSubmit(onSubmitEditar)}>Actualizar</button>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6  row p-1 pb-2 g-2">
                        {/* Compañía, sucursal y sedes: resumen + modal "Accesos por organización" */}
                        <UsuarioFormOrganizacion {...props} />

                        <div className="col-12 ">
                            <div className="d-flex align-items-center">
                                <label className="col-4 text-start px-2">Usuario</label>
                                <input
                                    {...register("usuario", {
                                        required: { value: true, message: "Ingrese el usuario" },
                                        // INCIDENCIA Validaciones (2026-08-17): el usuario no debe llevar
                                        // espacios ni simbolos (feedback inmediato; el back re-valida).
                                        validate: (v: any) => {
                                            // En editar el usuario es readOnly (no se puede cambiar): no se
                                            // valida para no bloquear la edicion de cuentas legadas.
                                            if (accion === "editar") return true;
                                            const val = (v ?? "").toString();
                                            if (/\s/.test(val)) return "El usuario no debe contener espacios";
                                            if (!/^[A-Za-z0-9._@-]+$/.test(val.trim())) return "El usuario solo puede tener letras, números, punto, guion o guion bajo";
                                            return true;
                                        }
                                    })}
                                    type="text"
                                    className="form-control form-control-sm"
                                    autoComplete="off"
                                    readOnly={accion === "editar" ? true : false}
                                />
                            </div>
                            {errors.usuario && <p role="alert" className="error px-2 mb-0">{errors.usuario.message}</p>}
                        </div>
                    </div>
                </div>
            </div>
    )
}
